import { render, staticRenderFns } from "./ThreeCutMinimumModal.vue?vue&type=template&id=21a6b874&"
import script from "./ThreeCutMinimumModal.vue?vue&type=script&lang=js&"
export * from "./ThreeCutMinimumModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports